module.exports = __webpack_public_path__ + "img/didacticiel-radar.528e42b1.svg";